"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationToken = void 0;
var cancellationToken_1 = require("./cancellationToken");
Object.defineProperty(exports, "CancellationToken", { enumerable: true, get: function () { return cancellationToken_1.CancellationToken; } });
//# sourceMappingURL=index.js.map